<template>
	<div id="app" class="font-sans">
		<router-view></router-view>
	</div>
</template>

<script>
import { USER_REQUEST } from '@/store/actions/user';
export default {
	name: 'app',
	created: function () {
		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch(USER_REQUEST);
		}
	},
};
</script>

<style>
#app {
	color: #2c3e50;
}
* {
	box-sizing: border-box;
}
</style>
